import type { CrosswordsType } from "@product/scmp-sdk";

export const pathname = "/games/crossword/archive";

export const page = {
  route(query: QueryParameters<{ crosswordsType?: CrosswordsType }>) {
    return { pathname, query: { ...query, pageType: "crossword" } };
  },
};
